module.exports = __webpack_public_path__ + "static/media/sound.762ca866.png";